function expandSearchResultsFilter() {
    const $filtersMobile = document.getElementById('filtersMobileTrigger');
    const $searchFiltersBasic = document.querySelector('.search-filters__basic');
    const $searchFiltersAdvanced = document.querySelector('.search-filters__advanced');
    const searchFiltersBasicExpandedClass = 'search-filters__basic--withAdvanced';
    const searchFiltersAdvancedExpandedClass = 'search-filters__advanced--expanded';

    function onFiltersClick(e) {
        e.preventDefault();
        scrollTop(500);
        expandFilters();
    }

    function expandFilters() {
        if (
            window.scrollY === 0
        ) {
            // $filtersMobile.classList.toggle('active');
            $searchFiltersBasic.classList.toggle(searchFiltersBasicExpandedClass);
            $searchFiltersAdvanced.classList.toggle(searchFiltersAdvancedExpandedClass);
        }
    }

    if($filtersMobile) {
        $filtersMobile.addEventListener('click', onFiltersClick, false);
        // $filtersMobile.addEventListener('touchstart', onFiltersClick, false);
    }

}

function expandSearchResultsMap() {
    const $mapMobileTrigger = document.getElementById('mapMobileTrigger');
    const $map = document.getElementById('mapTrigger');
    let touchEvent = new Event('touchstart');

    function onMapClick(e) {
        // console.log(e);
        e.preventDefault();
        scrollTop(500);
        expandMap();
    }

    function expandMap() {
        if (
            window.scrollY === 0 ||
            window.scrollY > 0 && (!$mapMobileTrigger.classList.contains('active'))
        ) {
            $map.click();
            // $mapMobileTrigger.dispatchEvent(touchEvent);
            $mapMobileTrigger.classList.toggle('active');
        }
    }

    if($mapMobileTrigger) {
        $mapMobileTrigger.addEventListener('click', onMapClick, false);
        // $mapMobileTrigger.addEventListener('touchstart', onMapClick, false);
    }
}

function scrollTop(duration) {
    const scrollStep = -window.scrollY / (duration / 30);

    if (window.innerWidth > 768) {
        const scrollInterval = setInterval(() => {
            if (window.scrollY !== 0) {
                window.scrollBy(0, scrollStep);
            } else {
                clearInterval(scrollInterval)
            }
        }, 30);
    } else {
        window.scrollTo(0,0)
    }
}

function firePixelFacebookSearchEvent() {
    if (typeof fbq === "function"){
        fbq('track', 'Search');
    }
}

function init() {
    expandSearchResultsFilter();
    expandSearchResultsMap();
    firePixelFacebookSearchEvent();
}

window.onload = function () {
    init();
};
